import { Http, CustomRequestConfig } from '@/lib/http';

import {
  GetGetRatingDetailQuery,
  GetGetRatingDetailRes,
  GetGetStationScoreDetailQuery,
  GetGetStationScoreDetailRes,
  GetGetStationScoreListQuery,
  GetGetStationScoreListRes,
  GetGetStationScoreTrendQuery,
  GetGetStationScoreTrendRes
} from './rating.type';

export const API_URL = {
  /* 评分列表 */
  GetStationScoreListURL: '/web/comment/getStationScoreList',
  /* 评分详情 */
  GetStationScoreDetailURL: '/web/comment/getUserScoreInfo',
  /* 评分趋势 */
  GetStationScoreTrendURL: '/web/comment/getStationScoreTrend',
  /* 用户评分预览 */
  GetRatingDetailURL: '/web/comment/getRatingDetail'
};

export class RatingApiModule {
  /** 评分列表
   * @link 接口文档 todo
   */
  static getGetStationScoreList(
    params: GetGetStationScoreListQuery,
    exParams?: CustomRequestConfig
  ) {
    return Http<GetGetStationScoreListRes>({
      url: API_URL.GetStationScoreListURL,
      method: 'GET',
      params,
      ...exParams
    });
  }

  /**
   * 评分详情
   * @link 接口文档
   * @updateTime 5/7/2025, 2:50:02 PM
   */
  static getGetStationScoreDetail(
    params: GetGetStationScoreDetailQuery,
    exParams?: CustomRequestConfig
  ) {
    return Http<GetGetStationScoreDetailRes>({
      method: 'GET',
      url: API_URL.GetStationScoreDetailURL,
      params,
      ...exParams
    });
  }

  /**
   * 评分趋势
   * @link 接口文档
   * @updateTime 5/7/2025, 3:46:55 PM
   */
  static getGetStationScoreTrend(
    params: GetGetStationScoreTrendQuery,
    exParams?: CustomRequestConfig
  ) {
    return Http<GetGetStationScoreTrendRes>({
      method: 'GET',
      url: API_URL.GetStationScoreTrendURL,
      params,
      ...exParams
    });
  }

  /**
   * 用户评分预览
   * @link 接口文档
   * @updateTime 5/7/2025, 3:46:55 PM
   */
  static getGetRatingDetail(params: GetGetRatingDetailQuery, exParams?: CustomRequestConfig) {
    return Http<GetGetRatingDetailRes>({
      method: 'GET',
      url: API_URL.GetRatingDetailURL,
      params,
      ...exParams
    });
  }
}

export default RatingApiModule;
